import React from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { numberWithComma } from 'helpers/format'
import { Data, Product } from 'Store/orders/types'
import { Col, Row } from 'antd'
import { PaymentType, VAT_TYPE, VAT_TYPE_TEXT } from 'helpers/constanst'
import { themeConfig } from 'config'

type Props = {
  detail?: Data
}

const OrderSummary: React.FunctionComponent<Props> = props => {
  const { detail } = props
  // const [selectedGrn, setSelectedGrn] = useState([] as SelectedProductsGrn[])

  const products = detail?.products[0]?.products || []
  const isCod = detail?.payment_detail?.payment_type === PaymentType.COD

  const getTotalBeforeDiscount = () => {
    let total = 0
    products.forEach((item: Product) => {
      total += item.price_before_discount
    })
    return total
  }

  const getTotalDiscount = () => {
    let total = 0
    products.forEach((item: Product) => {
      total += item.total_discount
    })
    return total
  }

  const getTotalProductPrice = () => {
    let total = 0
    products.forEach((item: Product) => {
      total += item.total_price
    })
    return total
  }

  const renderInfoItem = (title: any, value: any) => {
    return (
      <Row justify="space-between">
        <Col>
          <InfoTitle>{title}</InfoTitle>
        </Col>
        <Col offset={1}>
          <InfoValue>{value || '-'}</InfoValue>
        </Col>
      </Row>
    )
  }

  const totalBeforeDiscount = getTotalBeforeDiscount()
  const totalDiscount = getTotalDiscount()
  const tailDiscount = detail?.payment_detail?.tail_discount_amount || 0
  const totalProductPrice = getTotalProductPrice() - tailDiscount
  const shippingPrice = detail?.products[0]?.shipping_price || 0
  const paymentFee = detail?.products[0]?.payment_fee || 0
  const total = detail?.payment_detail?.total || 0
  const couponDiscount = detail?.payment_detail?.coupon_discount_amount || 0
  const isBigBangPromo = (detail?.payment_detail?.bigbang_promotion_discount || 0) > 0
  const hasProductDiscount = totalDiscount > 0
  const isExcludeVat = detail?.payment_detail?.vat_type === VAT_TYPE.EX
  const isTax = detail?.payment_detail.is_tax
  const vatType = detail?.payment_detail?.vat_type
  const vatAmount = detail?.payment_detail?.vat_amount || 0
  return (
    <Row justify="end">
      <Col md={12} xs={24}>
        {hasProductDiscount &&
          renderInfoItem('รวมราคาสินค้าก่อนหักส่วนลด', `${numberWithComma(totalBeforeDiscount, true)} บาท`)}
        {hasProductDiscount &&
          renderInfoItem('หัก ส่วนลดสินค้า', `${numberWithComma(totalDiscount, true)} บาท`)}
        {renderInfoItem('รวมราคาสินค้า', `${numberWithComma(getTotalProductPrice(), true)} บาท`)}
        {tailDiscount > 0 &&
          renderInfoItem(`หัก ส่วนลดท้ายบิล`, `${numberWithComma(tailDiscount, true)} บาท`)}
        {tailDiscount > 0 &&
          renderInfoItem('ราคารวมทั้งสิ้น ', `${numberWithComma(totalProductPrice, true)} บาท`)}
        {isExcludeVat &&
          isTax &&
          renderInfoItem(
            `ภาษีมูลค่าเพิ่ม 7% (${vatType === VAT_TYPE.EX ? VAT_TYPE_TEXT.EX : VAT_TYPE_TEXT.IN})`,
            `${numberWithComma(vatAmount, true)} บาท`,
          )}
        {renderInfoItem('ค่าจัดส่ง', `${numberWithComma(shippingPrice, true)} บาท`)}
        {isCod && renderInfoItem('ค่าธุรกรรมทางการเงิน', `${numberWithComma(paymentFee, true)} บาท`)}
        {couponDiscount > 0 && <Remark>คำสั่งซื้อนี้มีการใช้คูปองส่วนลดร่วมด้วย</Remark>}
        {isBigBangPromo && (
          <Row>
            <Col span={20}>
              <Remark>
                คำสั่งซื้อนี้มีโปรโมชันส่งเสริมการขายประเภทส่วนลดพิเศษจาก {themeConfig.title.appName} ร่วมด้วย
              </Remark>
            </Col>
          </Row>
        )}
        {renderInfoItem('จำนวนเงินรวมทั้งสิ้น', <Bold>{numberWithComma(total, true)} บาท</Bold>)}
      </Col>
    </Row>
  )
}

const InfoTitle = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const InfoValue = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  margin-right: 10px;
`

const Bold = styled.span`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
`

const Remark = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
`

export default OrderSummary
